var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPeople = function SvgPeople(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 17.5003V2.50033C3.33325 2.04033 3.70659 1.66699 4.16659 1.66699H14.1666C15.5474 1.66699 16.6666 2.78616 16.6666 4.16699V15.8337C16.6666 17.2145 15.5474 18.3337 14.1666 18.3337H4.16659C3.70659 18.3337 3.33325 17.9603 3.33325 17.5003Z",
    fill: "#E3F2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C11.3807 10 12.5 8.88071 12.5 7.5C12.5 6.11929 11.3807 5 10 5C8.61929 5 7.5 6.11929 7.5 7.5C7.5 8.88071 8.61929 10 10 10Z",
    fill: "#1F87E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 11.667H7.49992C6.57909 11.667 5.83325 12.4128 5.83325 13.3337C5.83325 14.2545 6.57909 15.0003 7.49992 15.0003H12.4999C13.4208 15.0003 14.1666 14.2545 14.1666 13.3337C14.1666 12.4128 13.4208 11.667 12.4999 11.667Z",
    fill: "#1F87E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 12.5C3.20508 12.5 3.07758 12.5 2.91675 12.5C2.22675 12.5 1.66675 13.06 1.66675 13.75C1.66675 14.44 2.22675 15 2.91675 15C3.07758 15 3.20508 15 3.33341 15V12.5Z",
    fill: "#90C9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 5C3.20508 5 3.07758 5 2.91675 5C2.22675 5 1.66675 5.56 1.66675 6.25C1.66675 6.94 2.22675 7.5 2.91675 7.5C3.07758 7.5 3.20508 7.5 3.33341 7.5V5Z",
    fill: "#90C9F9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPeople);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "people.18e812d6bb9560b21f59ca29be95ddfe.svg";